"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactForm = contactForm;
exports.bezichtigingForm = bezichtigingForm;
exports.nieuwsbriefForm = nieuwsbriefForm;
exports.nieuwsbriefBuitengewoon = nieuwsbriefBuitengewoon;
exports.bouwkundigeKeuringForm = bouwkundigeKeuringForm;
exports.taxatieForm = taxatieForm;
exports.searchForm = searchForm;
function createForm(route, fields, gtmEvent, withPhone = true) {
    return {
        loading: false,
        formData: fields,
        errorMessage: "",
        send: false,
        submitForm() {
            return __awaiter(this, void 0, void 0, function* () {
                this.loading = true;
                const res = yield sendData(route, this.formData);
                this.loading = false;
                if (res !== true) {
                    this.errorMessage = res;
                    return;
                }
                this.send = true;
                customGtmEvent(Object.assign({ event: gtmEvent, email: this.formData.email }, (withPhone ? { phone: this.formData.tel } : {})));
            });
        },
    };
}
function contactForm() {
    return createForm('contact', {
        firstname: "",
        lastname: "",
        email: "",
        tel: "",
        message: "",
        policy: false
    }, 'contact_opgenomen');
}
function bezichtigingForm() {
    return createForm('bezichtiging', {
        firstname: "",
        lastname: "",
        email: "",
        tel: "",
        policy: false
    }, 'bezichtiging_ingepland');
}
function nieuwsbriefForm() {
    return createForm('nieuwsbrief', {
        firstname: "",
        lastname: "",
        email: "",
        policy: false
    }, 'nieuwsbrief_inschrijving', false);
}
function nieuwsbriefBuitengewoon() {
    return createForm('nieuwsbrief-buitengewoon', {
        firstname: "",
        email: "",
        policy: false
    }, 'nieuwsbrief_inschrijving', false);
}
function bouwkundigeKeuringForm() {
    return createForm('bouwkundige-keuring', {
        firstname: "",
        lastname: "",
        tel: "",
        email: "",
        policy: false
    }, 'bouwkundige_keuring_aangevraagd');
}
function taxatieForm() {
    return createForm('taxatie', {
        firstname: "",
        lastname: "",
        tel: "",
        email: "",
        policy: false
    }, 'taxatie_aangevraagd');
}
function searchForm() {
    return createForm('search', {
        firstname: "",
        lastname: "",
        tel: "",
        email: "",
        type: "",
        huurKoop: "",
        place: "",
        policy: false
    }, 'zoekservice_aangevraagd');
}
function sendData(route, data) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield fetch(`/wp-json/forms/v1/${route}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify(data),
        });
        if (res.ok) {
            return true;
        }
        const jsonData = yield res.json();
        return jsonData.data;
    });
}
function customGtmEvent(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
}
